import { LOAD_OPERATIONS_DATA } from '../constants'

const operations = (state={}, action) => {
  switch(action.type) {
    case LOAD_OPERATIONS_DATA:
      return {...action.data}
    default:
      return state;
  }
}

export default operations


// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/reducers/operationsReducer.js